import { Component, ViewChild, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'formly-field-custom-yearpicker',
  template: `
    <div class="p-input-icon-right">
      <label for="buttondisplay">{{to.label}}</label>
      <p-calendar 
        #calendar
        [formControl]="formControl" 
        [formlyAttributes]="field"
        [(ngModel)]="date"
        [showIcon]="true"
        [iconDisplay]="'input'"
        view="month" 
        dateFormat="mm/yy"
        placeholder="Select year">
      </p-calendar>
      <div *ngIf="showError" class="formly-validation-message">
        <small class="p-error">{{ errorMessage }}</small>
      </div>
    </div>
  `,
  styles:`
    ::ng-deep .p-highlight {
      color: #D47500;
      background: #FFF1E0;
    }
    .p-error {
       color: #e24c4c;
       font-size: 13px;
       margin-top: 4px;
       font-weight: 500;
    }
  `
})
export class CustomYearpickerTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  
  @ViewChild('calendar') calendar!: Calendar;
  date!: Date;

  ngOnInit() {
    this.initializeDate();
  }

  private initializeDate() {
    const value = this.formControl.value;

    if (value) {
      let dateValue: Date | null = null;

      if (value instanceof Date) {
        dateValue = value;
      } else if (typeof value === 'string') {
        dateValue = this.parseDateFromString(value);
      }

      if (dateValue) {
        this.date = dateValue;
        this.formControl.setValue(dateValue);
      }
    }
  }

  private parseDateFromString(value: string): Date | null {
    const [month, year] = value.split('/').map(Number);
    if (!isNaN(month) && !isNaN(year)) {
      return new Date(year, month - 1);
    }
    return null;
  }

  get errorMessage(): string | null {
    if (this.formControl.hasError('required')) {
      return `${this.to.label} is required`;
    }
    return null;
  }
}
